// removed by extract-text-webpack-plugin
module.exports = {"container":"container__2hmBL","content":"content__1228s","bar":"bar__2wFkL","heads":"heads__2rI8v","title":"title__3tGpl"};


//////////////////
// WEBPACK FOOTER
// ./components/about/about.css
// module id = cWBa
// module chunks = 0